<template>
	<div
		class="col-span-full mt-lg mb-10 flex w-full flex-col gap-x-4 gap-y-6 md:mt-xl md:gap-y-0 lg:flex-row"
	>
		<template v-for="brand in brands" :key="brand.uuid">
			<sb-brand-card-big :blok="brand"></sb-brand-card-big>
		</template>
	</div>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

import {useStoryblokStoriesList} from "@pkg/shared/composables/use-storyblok-stories-list";

const properties = defineProps<{
	blok: ISbStoryData[];
}>();

const brandUuids = properties.blok.join(",");

const {t} = useI18n();

const {
	data: {value: brands},
} = await useStoryblokStoriesList(`brands-${brandUuids}`, {
	starts_with: `${t("storyblok.brands-page")}/`,
	by_uuids: brandUuids,
});
</script>
